import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    who: "Anett & David",
    where: "Zámek Třebušín",
    when: "7. září 2019",
    whenLong: "7. 9. - 8. 9. 2019",
    menu: [{
      name: 'home',
      title: 'Oznámení',
      icon: 'home'
    }, {
      name: 'hosts',
      title: 'Pro hosty',
      icon: 'people'
    }, {
      name: 'fotogallery',
      title: 'Fotogalerie',
      icon: 'photo'
    }]
  },
  getters: {
    who: state => state.who,
    where: state => state.where,
    when: state => state.when,
    whenLong: state => state.whenLong,
    menu: state => state.menu
  }
})
